import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/projects/join/$token')({
  staticData: { requiresAuth: true },

  async beforeLoad({ context, params }) {
    await context.auth.requireAuth({
      pathname: `/projects/join/${params.token}`,
      search: {},
    });
  },
});
